import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8,
    padding: theme.spacing(2)
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2)
  },
  buttons: { display: 'flex', gap: 8 },
  title: {
    fontWeight: 600,
    color: theme.palette.text.primary
  },
  subTitle: {
    fontSize: 14,
    fontWeight: 500,
    color: theme.palette.grey[600],
    marginTop: 2
  },
  circularProgress: {
    marginLeft: 8,
    color: theme.palette.primary.main
  },
  btnText: { fontWeight: 500, color: theme.palette.text.primary },
  btnText2: { fontWeight: 500, color: theme.palette.primary.contrastText },
  container: {
    border: `1px solid ${theme.palette.grey[400]}`,
    borderRadius: 8,
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    margin: '16px 0',
    padding: 16,
    gap: 16,
    alignItems: 'flex-end'
    // background: 'pink'
  },
  input: { marginBottom: 12 },
  startIcon: {
    marginRight: -4
  },
  filterButton: {
    height: 40,
    textTransform: 'none'
  },
  tableWrapper: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 6,
    overflow: 'hidden',
    height: '60vh'
  },
  // Always 10 tracks -- checkbox, 8 sortable columns, Actions -- matching
  // SessionRow's own grid unconditionally. BL-235: this used to grow to 10 columns
  // only while a bulk selection was active (to host the shared bulk-terminate
  // button), while the row grid grew in sync but never rendered anything into its
  // own 10th column -- a header that implied a column the rows never delivered.
  // The bulk-terminate button now lives in the toolbar instead, and the Actions
  // column always holds each row's own per-session terminate control.
  tableHeader: {
    display: 'grid',
    gridTemplateColumns: '0.3fr 1fr 1.4fr 1fr 1fr 1fr 1fr 1fr 1fr 0.8fr',
    alignItems: 'center',
    padding: theme.spacing(1),
    backgroundColor: theme.palette.grey[200],
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    fontSize: 14,
    fontWeight: 500
  },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: 240,
    color: '#6b7280'
  },
  emptyIcon: {
    fontSize: 48,
    color: '#cbd5e1',
    marginBottom: theme.spacing(1)
  },
  emptyText: {
    fontSize: 14
  },
  tableSortLabel: {
    color: theme.palette.grey[800]
  },

  loadingContainer: {
    display: 'flex',
    width: '100%',
    height: '50vh',
    justifyContent: 'center',
    alignItems: 'center'
  },
  content: {
    display: 'grid',
    gridTemplateRows: '1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr',
    alignItems: 'center'
  },

  paginationContainer: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: theme.palette.background.default,
    marginTop: 12,
    paddingTop: 8,
    paddingBottom: 8,
    borderRadius: 12
  }
}))

export default useStyles
